module.exports = __webpack_public_path__ + "img/header_background.a58053bd.png";